export enum CourseFontWeight {
  regular = 400,
  bold = 700,
}
